/* ============================================================
   COVRPACK — Page Produit Custom v2.3
   Fichier : assets/covrpack-product.js
   Changements v2.3 :
     - DISPONIBILITE par variante basee sur le STOCK REEL.
       Nouvelle fonction getVariantStock() + applyVariantAvailability()
       qui met a jour, a l'init ET a chaque changement d'onglet/variante :
         * le bouton "Ajouter au panier" (-> "Indisponible" + disabled)
         * le bouton sticky bar
         * la ligne stock ("En stock · 76 disponibles" / "Rupture de stock")
       Source de verite : window.cvrStockMap (calcule cote serveur),
       repli sur l'objet variante.
     - cvrAddToCart() refuse desormais l'ajout d'une variante indisponible
       (plus de tentative -> plus de "Erreur — reessayer" sur rupture).
   Changements v2.2 :
     - Galerie multi-media : cvrSwitchMedia (images + videos)
   ============================================================ */

(function () {
  'use strict';

  function tr(k, d, o) {
    var T = window.covrProductI18n || {};
    var s = (T[k] != null && T[k] !== '') ? T[k] : d;
    if (o) s = String(s).replace(/\{(\w+)\}/g, function (m, x) { return o[x] != null ? o[x] : m; });
    return s;
  }
  function numLocale() { return document.documentElement.lang || 'fr-FR'; }

  var CVR = {
    qty:            1,
    currentTab:     '',
    currentTierIdx: 0,
    tiers:          null,
    tabList:        null,
    subMode:        'once',
    carousels:      {},
    variants:       [],
  };

  /* ── INITIALISATION ── */
  document.addEventListener('DOMContentLoaded', function () {
    if (window.ShopifyProduct && window.ShopifyProduct.variants) {
      CVR.variants = window.ShopifyProduct.variants;
    }

    if (window.cvrTiersData) {
      CVR.tiers = window.cvrTiersData;

      CVR.tabList = Object.keys(CVR.tiers).map(function (sku) {
        var variant = CVR.variants.find(function (v) { return v.sku === sku; });
        return { sku: sku, label: variant ? variant.title : sku, variantId: variant ? variant.id : null };
      });

      var currentId = parseInt(document.querySelector('.cvr-product').dataset.variantId, 10);
      var currentVariant = CVR.variants.find(function (v) { return v.id === currentId; });
      CVR.currentTab = (currentVariant && CVR.tiers[currentVariant.sku]) ? currentVariant.sku : (CVR.tabList[0] ? CVR.tabList[0].sku : '');

      renderTabs();
      renderHybridTable();
    }

    initStickyBar();
    initCarousels();
    cvrPlayActiveVideo();
    applyVariantAvailability(); // etat stock de la variante affichee au chargement
  });

  /* ── DISPONIBILITE / STOCK ── */
  // Retourne { available, qty, tracked } pour un id de variante.
  // Priorite a window.cvrStockMap (fiable, calcule cote serveur).
  function getVariantStock(variantId) {
    var map = window.cvrStockMap || {};
    var s = map[variantId];
    if (s) return s;

    // Repli : objet variante (inventory_quantity pas toujours present)
    var variant = CVR.variants.find(function (v) { return v.id === variantId; });
    if (!variant) return { available: false, qty: 0, tracked: false };
    var tracked = !!variant.inventory_management;
    var qty = (typeof variant.inventory_quantity === 'number') ? variant.inventory_quantity : 0;
    return {
      available: (tracked && qty <= 0) ? false : !!variant.available,
      qty: qty,
      tracked: tracked
    };
  }

  // Met a jour bouton(s) d'achat + ligne stock selon la variante courante.
  function applyVariantAvailability() {
    var product = document.querySelector('.cvr-product');
    if (!product) return;
    var variantId = parseInt(product.dataset.variantId, 10);
    var stock = getVariantStock(variantId);

    // Bouton principal
    var cartBtn = document.getElementById('cvr-add-to-cart');
    if (cartBtn) {
      cartBtn.disabled = !stock.available;
      cartBtn.textContent = stock.available ? tr('add_to_cart', 'Ajouter au panier') : tr('unavailable', 'Indisponible');
    }

    // Bouton sticky bar
    var stickyBtn = document.querySelector('.cvr-sticky-bar__actions .cvr-btn-cart');
    if (stickyBtn) {
      stickyBtn.disabled = !stock.available;
      stickyBtn.textContent = stock.available ? tr('add_to_cart', 'Ajouter au panier') : tr('unavailable', 'Indisponible');
    }

    // Ligne stock
    var dot      = document.getElementById('cvr-stock-dot');
    var label    = document.getElementById('cvr-stock-label');
    var delivery = document.getElementById('cvr-stock-delivery');

    if (dot) dot.classList.toggle('is-in-stock', stock.available);

    if (label) {
      if (stock.available) {
        var txt = tr('in_stock', 'En stock');
        if (stock.tracked && stock.qty > 0) {
          txt += ' · ' + tr(stock.qty > 1 ? 'stock_available_many' : 'stock_available_one', stock.qty > 1 ? '{count} disponibles' : '{count} disponible', { count: formatNum(stock.qty) });
        }
        label.textContent = txt;
      } else {
        label.textContent = tr('out_of_stock', 'Rupture de stock');
      }
    }

    if (delivery) delivery.style.display = stock.available ? '' : 'none';
  }

  /* ── GALERIE (images + videos) ── */
  window.cvrSwitchMedia = function (btn) {
    var id = btn.getAttribute('data-media-id');
    var main = document.querySelector('.cvr-gallery__main');
    if (!main) return;
    main.querySelectorAll('.cvr-gallery__slide').forEach(function (slide) {
      var isActive = slide.getAttribute('data-media-id') === id;
      slide.classList.toggle('is-active', isActive);
      var vid = slide.querySelector('video');
      if (vid) {
        if (isActive) {
          vid.muted = true;
          var p = vid.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          try { vid.pause(); } catch (e) {}
        }
      }
    });
    document.querySelectorAll('.cvr-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
    btn.classList.add('is-active');
  };

  function cvrPlayActiveVideo() {
    var vid = document.querySelector('.cvr-gallery__slide.is-active video');
    if (vid) {
      vid.muted = true;
      var p = vid.play();
      if (p && p.catch) p.catch(function () {});
    }
  }

  /* ── ONGLETS TABLEAU DÉGRESSIF ── */
  function renderTabs() {
    var container = document.getElementById('cvr-ht-tabs');
    if (!container || !CVR.tabList) return;
    var html = '';
    CVR.tabList.forEach(function (tab) {
      var isActive = tab.sku === CVR.currentTab ? 'is-active' : '';
      html += '<button class="cvr-ht-tab ' + isActive + '" data-sku="' + tab.sku + '" onclick="cvrSwitchHT(\'' + tab.sku + '\', this)">' + tab.label + '</button>';
    });
    container.innerHTML = html;
  }

  function getUnitsForSku(sku) {
    var tab = CVR.tabList ? CVR.tabList.find(function (t) { return t.sku === sku; }) : null;
    if (tab) {
      var match = tab.label.match(/(\d[\d\s]*)/);
      if (match) return parseInt(match[1].replace(/\s/g, ''), 10);
    }
    return 1;
  }

  window.cvrSwitchHT = function (sku, btn) {
    CVR.currentTab = sku;
    CVR.currentTierIdx = 0;
    document.querySelectorAll('.cvr-ht-tab').forEach(function (b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');

    var tab = CVR.tabList ? CVR.tabList.find(function (t) { return t.sku === sku; }) : null;
    if (tab && tab.variantId) {
      document.querySelector('.cvr-product').dataset.variantId = tab.variantId;
      var v = CVR.variants.find(function (v) { return v.id === tab.variantId; });
      if (v) {
        window.cvrBasePrice = v.price;
        var refEl = document.getElementById('cvr-ref');
        if (refEl && v.sku) refEl.textContent = tr('ref', 'Réf.') + ' ' + v.sku;
      }
    }

    renderHybridTable();
    applyVariantAvailability(); // <-- maj bouton + ligne stock pour la nouvelle variante
    setTimeout(function () { selectTier(0); }, 0);
  };

  function getCurrentSku() {
    if (CVR.tiers && CVR.tiers[CVR.currentTab]) return CVR.currentTab;
    var variantId = parseInt(document.querySelector('.cvr-product').dataset.variantId, 10);
    if (variantId && CVR.variants.length) {
      var v = CVR.variants.find(function (v) { return v.id === variantId; });
      if (v && v.sku && CVR.tiers && CVR.tiers[v.sku]) return v.sku;
    }
    return CVR.currentTab;
  }

  function renderHybridTable() {
    var body = document.getElementById('cvr-ht-body');
    if (!body || !CVR.tiers) return;

    var sku = getCurrentSku();
    var data = CVR.tiers[sku];
    if (!data || !data.length) {
      body.innerHTML = '<div class="cvr-ht-loading">' + tr('prices_not_configured', 'Tarifs non configurés.') + '</div>';
      return;
    }

    var units = getUnitsForSku(sku);
    var basePriceUnit = data[0].unit_price;
    var html = '<table class="cvr-ht-table"><thead><tr><th>' + tr('quantity', 'Quantité') + '</th><th>' + tr('price_per_lot', 'Prix / lot') + '</th><th>' + tr('discount', 'Réduction') + '</th></tr></thead><tbody>';

    data.forEach(function (tier, i) {
      var discount = i === 0 ? 0 : Math.round((1 - tier.unit_price / basePriceUnit) * 100);
      var isActive = i === CVR.currentTierIdx ? 'is-active' : '';
      var badgeClass = discount > 0 ? 'has-discount' : '';
      var totalUnits = tier.qty * units;
      var qtyLabel = tier.qty === 1 ? tr('lot_one', '1 lot') : tr('lot_many', '{n} lots', { n: tier.qty });
      html += '<tr class="' + isActive + '" data-tier-idx="' + i + '" data-sku="' + sku + '" onclick="cvrSelectTier(this)">';
      html += '<td>' + qtyLabel + ' <span style="color:var(--cvr-grey);font-size:11px;">(' + formatNum(totalUnits) + ' ' + tr('unit_abbr', 'u') + ')</span></td>';
      html += '<td style="font-weight:700;">' + formatPrice(tier.unit_price) + ' €</td>';
      html += '<td><span class="cvr-ht-badge ' + badgeClass + '">' + (discount > 0 ? '-' + discount + '%' : '—') + '</span></td>';
      html += '</tr>';
    });

    html += '</tbody></table>';
    body.innerHTML = html;
    selectTier(CVR.currentTierIdx);
  }

  window.cvrSelectTier = function (row) {
    CVR.currentTab = row.dataset.sku;
    CVR.currentTierIdx = parseInt(row.dataset.tierIdx, 10);
    document.querySelectorAll('.cvr-ht-table tbody tr').forEach(function (r) { r.classList.remove('is-active'); });
    row.classList.add('is-active');
    selectTier(CVR.currentTierIdx);
  };

  function selectTier(idx) {
    var sku = getCurrentSku();
    var data = CVR.tiers[sku];
    if (!data || !data[idx]) return;
    CVR.qty = data[idx].qty;
    var qtyInput = document.getElementById('cvr-qty-main');
    if (qtyInput) qtyInput.value = CVR.qty;
    updatePriceDisplay();
  }

  /* ── AFFICHAGE PRIX ── */
  function getSubDiscount() {
    if (CVR.subMode !== 'repeat') return 0;
    var block = document.querySelector('.cvr-sub-block');
    if (!block) return 0;
    return (parseInt(block.dataset.discount, 10) || 5) / 100;
  }

  function updatePriceDisplay() {
    var sku = getCurrentSku();
    var data = CVR.tiers ? CVR.tiers[sku] : null;
    if (!data || !data.length) return;

    var tier           = data[CVR.currentTierIdx];
    var baseTier       = data[0];
    var units          = getUnitsForSku(sku);
    var multiplier     = (CVR.qty > tier.qty && tier.qty > 0) ? CVR.qty / tier.qty : 1;
    var totalQty       = tier.qty * multiplier;
    var totalUnits     = units * totalQty;
    var totalPrice     = tier.unit_price * totalQty;
    var pricePerUnit   = tier.unit_price / units;
    var baseTotalPrice = baseTier.unit_price * totalQty;
    var subDiscount    = getSubDiscount();
    var totalAfterSub  = totalPrice * (1 - subDiscount);

    var elTotal   = document.getElementById('cvr-disp-total');
    var elCrossed = document.getElementById('cvr-disp-crossed');
    var elSavings = document.getElementById('cvr-disp-savings');
    var elUnit    = document.getElementById('cvr-disp-unit');
    var elQty     = document.getElementById('cvr-disp-qty');

    if (elTotal) {
      elTotal.textContent = formatPrice(totalAfterSub) + ' €';
      elTotal.classList.toggle('has-discount', CVR.currentTierIdx > 0 || subDiscount > 0);
    }

    if (elCrossed) {
      if (subDiscount > 0) {
        elCrossed.textContent = formatPrice(totalPrice) + ' €';
        elCrossed.style.display = '';
      } else if (CVR.currentTierIdx > 0 && baseTotalPrice > totalPrice + 0.01) {
        elCrossed.textContent = formatPrice(baseTotalPrice) + ' €';
        elCrossed.style.display = '';
      } else {
        elCrossed.style.display = 'none';
      }
    }

    if (elSavings) {
      var savings = subDiscount > 0 ? totalPrice - totalAfterSub : (CVR.currentTierIdx > 0 ? baseTotalPrice - totalPrice : 0);
      if (savings > 0.01) {
        elSavings.textContent = tr('savings_label', 'Économie :') + ' ' + formatPrice(savings) + ' €';
        elSavings.style.display = '';
      } else {
        elSavings.style.display = 'none';
      }
    }

    if (elUnit) elUnit.textContent = formatPrice(pricePerUnit, 4) + ' €/' + tr('unit_abbr', 'u');
    if (elQty)  elQty.textContent  = formatNum(Math.round(totalUnits));

    var stickyPrice = document.getElementById('cvr-sticky-price');
    if (stickyPrice) stickyPrice.textContent = formatPrice(totalAfterSub) + ' €';

    updateSubDisplay(totalPrice);
  }

  function updateSubDisplay(base) {
    var elNew = document.getElementById('cvr-sub-price-new');
    if (!elNew) return;
    var discount = getSubDiscount() || 0.05;
    var elOld = document.getElementById('cvr-sub-price-old');
    var elSav = document.getElementById('cvr-sub-savings');
    elNew.textContent = formatPrice(base * (1 - discount)) + ' €';
    if (elOld) elOld.textContent = formatPrice(base) + ' €';
    if (elSav) elSav.textContent = '−' + formatPrice(base * discount) + ' €';
  }

  /* ── QUANTITÉ ── */
  window.cvrAdjustQty = function (delta) {
    var input = document.getElementById('cvr-qty-main');
    var val = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
    input.value = val;
    CVR.qty = val;
    syncTierFromQty(val);
  };

  window.onQtyInput = function (val) {
    CVR.qty = Math.max(1, parseInt(val, 10) || 1);
    syncTierFromQty(CVR.qty);
  };

  function syncTierFromQty(qty) {
    var sku  = getCurrentSku();
    var data = CVR.tiers ? CVR.tiers[sku] : null;
    if (!data) { updatePriceDisplay(); return; }
    var matchIdx = 0;
    for (var i = 0; i < data.length; i++) {
      if (data[i].qty <= qty) matchIdx = i;
    }
    CVR.currentTierIdx = matchIdx;
    document.querySelectorAll('.cvr-ht-table tbody tr').forEach(function (r, i) {
      r.classList.toggle('is-active', i === matchIdx);
    });
    updatePriceDisplay();
  }

  /* ── ABONNEMENT ── */
  window.cvrSubTab = function (mode, btn) {
    CVR.subMode = mode;
    document.querySelectorAll('.cvr-sub-tab').forEach(function (b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');
    document.getElementById('cvr-sub-once').style.display = mode === 'once' ? '' : 'none';
    document.getElementById('cvr-sub-repeat').style.display = mode === 'repeat' ? '' : 'none';
    updatePriceDisplay();
  };

  /* ── ONGLETS PRODUIT ── */
  window.cvrSwitchTab = function (tab, btn) {
    document.querySelectorAll('.cvr-tab-panel').forEach(function (p) { p.style.display = 'none'; });
    document.querySelectorAll('.cvr-tab').forEach(function (b) { b.classList.remove('is-active'); });
    var panel = document.getElementById('cvr-tab-' + tab);
    if (panel) panel.style.display = '';
    btn.classList.add('is-active');
  };

  /* ── PANIER AJAX ── */
  window.cvrAddToCart = function () {
    var product   = document.querySelector('.cvr-product');
    var variantId = product ? parseInt(product.dataset.variantId, 10) : null;
    if (!variantId) return;

    // Securite : variante indisponible -> on n'essaie pas (le bouton est deja disabled)
    var stock = getVariantStock(variantId);
    if (!stock.available) {
      applyVariantAvailability();
      return;
    }

    var qty     = parseInt(document.getElementById('cvr-qty-main').value, 10) || 1;
    var cartBtn = document.getElementById('cvr-add-to-cart');
    if (cartBtn) { cartBtn.disabled = true; cartBtn.textContent = tr('adding', 'Ajout en cours…'); }

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body:    JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Erreur ' + r.status);
      return r.json();
    })
    .then(function () {
      if (cartBtn) { cartBtn.disabled = false; cartBtn.textContent = tr('added', '✓ Ajouté !'); }
      setTimeout(function () { if (cartBtn) applyVariantAvailability(); }, 2000);
      document.dispatchEvent(new CustomEvent('cart:updated'));
      if (window.theme && window.theme.cart && typeof window.theme.cart.open === 'function') window.theme.cart.open();
    })
    .catch(function (err) {
      console.error('Erreur panier :', err);
      if (cartBtn) { cartBtn.disabled = false; cartBtn.textContent = tr('error_retry', 'Erreur — réessayer'); }
    });
  };

  /* ── CROSS-SELL ADD TO CART ── */
  window.cvrCsAdd = function (btn) {
    var variantId = parseInt(btn.dataset.variantId, 10);
    var card = btn.closest('.cvr-cs-card');
    var input = card ? card.querySelector('.cvr-cs-qty-input') : null;
    var qty = input ? (parseInt(input.value, 10) || 1) : 1;
    btn.innerHTML = '✓';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Erreur ' + r.status);
      return r.json();
    })
    .then(function () {
      setTimeout(function () {
  btn.classList.remove('is-added');
  btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
}, 1200);
      document.dispatchEvent(new CustomEvent('cart:updated'));
      if (window.theme && window.theme.cart && typeof window.theme.cart.open === 'function') window.theme.cart.open();
    })
    .catch(function () { btn.classList.remove('is-added'); });
  };

  /* ── CARROUSELS ── */
  function initCarousels() {
    CVR.carousels = { compat: 0, bundle: 0 };
    initDots('compat');
    initDots('bundle');
  }

  function initDots(id) {
    setTimeout(function () { renderDots(id); }, 100);
    window.addEventListener('resize', function () { renderDots(id); });
  }

  function getGap(id) { return id === 'bundle' ? 10 : 8; }

  window.cvrSlide = function (id, dir) {
    var track = document.getElementById('cvr-' + id + '-track');
    if (!track) return;
    var cards = track.querySelectorAll('.cvr-cs-card');
    if (!cards.length) return;
    var cardWidth = cards[0].offsetWidth + getGap(id);
    var visible = Math.max(1, Math.floor(track.parentNode.offsetWidth / cardWidth));
    var max = Math.max(0, cards.length - visible);
    CVR.carousels[id] = Math.min(max, Math.max(0, (CVR.carousels[id] || 0) + dir));
    track.style.transform = 'translateX(-' + CVR.carousels[id] * cardWidth + 'px)';
    renderDots(id);
  };

  window.cvrSlideTo = function (id, page) {
    var track = document.getElementById('cvr-' + id + '-track');
    if (!track) return;
    var cards = track.querySelectorAll('.cvr-cs-card');
    if (!cards.length) return;
    var cardWidth = cards[0].offsetWidth + getGap(id);
    var visible = Math.max(1, Math.floor(track.parentNode.offsetWidth / cardWidth));
    var max = Math.max(0, cards.length - visible);
    CVR.carousels[id] = Math.min(max, page * visible);
    track.style.transform = 'translateX(-' + CVR.carousels[id] * cardWidth + 'px)';
    renderDots(id);
  };

  function renderDots(id) {
    var dotsContainer = document.getElementById('cvr-' + id + '-dots');
    var track = document.getElementById('cvr-' + id + '-track');
    if (!dotsContainer || !track) return;
    var cards = track.querySelectorAll('.cvr-cs-card');
    if (!cards.length) return;
    var cardWidth = cards[0].offsetWidth + getGap(id);
    var visible = Math.max(1, Math.floor(track.parentNode.offsetWidth / cardWidth));
    var totalDots = Math.max(1, Math.ceil(cards.length / visible));
    var currentPage = Math.floor((CVR.carousels[id] || 0) / visible);
    var html = '';
    for (var i = 0; i < totalDots; i++) {
      html += '<button class="cvr-carousel-dot' + (i === currentPage ? ' is-active' : '') + '" onclick="cvrSlideTo(\'' + id + '\', ' + i + ')"></button>';
    }
    dotsContainer.innerHTML = html;
  }

  /* ── STICKY BAR ── */
  function initStickyBar() {
    var bar  = document.getElementById('cvr-sticky-bar');
    var hero = document.querySelector('.cvr-hero');
    if (!bar || !hero) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(hero);
  }

  /* ── UTILITAIRES ── */
  function formatPrice(val, decimals) {
    return parseFloat(val).toFixed(decimals !== undefined ? decimals : 2).replace('.', ',');
  }

  function formatNum(val) {
    return parseInt(val, 10).toLocaleString(numLocale());
  }

})();

/* ============================================================
   COVRPACK — Modal produit cross-sell (v1.0)
   À APPENDRE à la fin de assets/covrpack-product.js
   (bloc IIFE autonome, expose window.cvrOpenModal & co.)

   Auto-adaptatif :
     - produit AVEC tiers (metafield tiers_json) -> tableau dégressif
       + prix calculé selon la quantité (lots).
     - produit SANS tiers -> prix simple × quantité.
     - sélecteur de variante affiché seulement si > 1 variante.
   ============================================================ */

(function () {
  'use strict';

  function tr(k, d, o) {
    var T = window.covrProductI18n || {};
    var s = (T[k] != null && T[k] !== '') ? T[k] : d;
    if (o) s = String(s).replace(/\{(\w+)\}/g, function (m, x) { return o[x] != null ? o[x] : m; });
    return s;
  }
  function numLocale() { return document.documentElement.lang || 'fr-FR'; }

  var M = {
    variants: [], tiers: null, variant: null, sku: '',
    units: 1, qty: 1, tierIdx: 0,
    images: [], imgIdx: 0, url: '#', title: ''
  };

  /* ── OUVERTURE ── */
  window.cvrOpenModal = function (el) {
    var card = el.closest('.cvr-cs-card');
    if (!card) return;
    var detail = card.querySelector('.cvr-cs-detail');
    if (!detail) return;

    // Données
    try { M.variants = JSON.parse(detail.querySelector('.cvr-cs-variants').textContent); }
    catch (e) { M.variants = []; }
    try { M.tiers = JSON.parse(detail.querySelector('.cvr-cs-tiers').textContent); }
    catch (e) { M.tiers = null; }

    M.images = Array.prototype.map.call(
      detail.querySelectorAll('.cvr-cs-detail-images span'),
      function (s) { return s.getAttribute('data-img'); }
    ).filter(Boolean);
    M.imgIdx = 0;
    M.url   = detail.getAttribute('data-url') || '#';
    M.title = detail.getAttribute('data-title') || '';

    // Titre, specs, lien fiche produit
    setText('cvr-modal-title', M.title);
    var specsSrc = detail.querySelector('.cvr-cs-detail-specs');
    var specsDst = document.getElementById('cvr-modal-specs');
    if (specsDst) {
      specsDst.innerHTML = specsSrc ? specsSrc.innerHTML : '';
      specsDst.style.display = (specsSrc && specsSrc.innerHTML.trim()) ? '' : 'none';
    }
    var view = document.getElementById('cvr-modal-view');
    if (view) view.setAttribute('href', M.url);

    // Variante par défaut : 1re disponible, sinon 1re
    var def = M.variants.find(function (v) { return v.available; }) || M.variants[0] || null;
    buildVariantSelect(def);
    selectVariant(def ? def.id : null);

    renderGallery();

    var modal = document.getElementById('cvr-modal');
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cvr-modal-open');
  };

  /* ── FERMETURE ── */
  window.cvrCloseModal = function () {
    var modal = document.getElementById('cvr-modal');
    if (!modal) return;
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cvr-modal-open');
  };

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var modal = document.getElementById('cvr-modal');
      if (modal && !modal.hidden) cvrCloseModal();
    }
  });

  /* ── VARIANTES ── */
  function buildVariantSelect(def) {
    var wrap = document.getElementById('cvr-modal-variant-wrap');
    var sel  = document.getElementById('cvr-modal-variant');
    if (!wrap || !sel) return;
    if (M.variants.length > 1) {
      var html = '';
      M.variants.forEach(function (v) {
        var dis = v.available ? '' : ' (' + tr('unavailable', 'Indisponible').toLowerCase() + ')';
        html += '<option value="' + v.id + '"' + (def && v.id === def.id ? ' selected' : '') + '>' + escapeHtml(v.title) + dis + '</option>';
      });
      sel.innerHTML = html;
      wrap.style.display = '';
    } else {
      wrap.style.display = 'none';
    }
  }

  window.cvrModalSelectVariant = function (id) { selectVariant(parseInt(id, 10)); };

  function selectVariant(id) {
    M.variant = M.variants.find(function (v) { return v.id === id; }) || M.variants[0] || null;
    M.sku   = M.variant ? (M.variant.sku || '') : '';
    M.units = parseUnits(M.variant ? M.variant.title : '');

    // Réf
    setText('cvr-modal-ref', M.sku ? (tr('ref', 'Réf.') + ' ' + M.sku) : '');

    // Tiers ou prix simple
    var data = (M.tiers && M.sku && M.tiers[M.sku] && M.tiers[M.sku].length) ? M.tiers[M.sku] : null;
    if (data) {
      M.tierIdx = 0;
      M.qty = data[0].qty;
      renderTiers(data);
    } else {
      M.tierIdx = 0;
      M.qty = 1;
      hideTiers();
    }
    var qi = document.getElementById('cvr-modal-qty');
    if (qi) qi.value = M.qty;

    // Bouton achat selon disponibilité
    var add = document.getElementById('cvr-modal-add');
    if (add) {
      var ok = !M.variant || M.variant.available;
      add.disabled = !ok;
      add.textContent = ok ? tr('add_to_cart', 'Ajouter au panier') : tr('unavailable', 'Indisponible');
      add.classList.remove('is-added');
    }

    updatePrice();
  }

  /* ── TABLEAU DÉGRESSIF ── */
  function renderTiers(data) {
    var box = document.getElementById('cvr-modal-tiers');
    if (!box) return;
    var base = data[0].unit_price;
    var html = '<table><thead><tr><th>' + tr('quantity', 'Quantité') + '</th><th>' + tr('price_per_lot', 'Prix / lot') + '</th><th>' + tr('discount', 'Réduction') + '</th></tr></thead><tbody>';
    data.forEach(function (t, i) {
      var disc = i === 0 ? 0 : Math.round((1 - t.unit_price / base) * 100);
      var totU = t.qty * M.units;
      var lbl  = t.qty === 1 ? tr('lot_one', '1 lot') : tr('lot_many', '{n} lots', { n: t.qty });
      html += '<tr class="' + (i === M.tierIdx ? 'is-active' : '') + '" data-idx="' + i + '" onclick="cvrModalSelectTier(' + i + ')">';
      html += '<td>' + lbl + ' <span style="color:var(--cvr-grey);font-size:11px;">(' + formatNum(totU) + ' ' + tr('unit_abbr', 'u') + ')</span></td>';
      html += '<td style="font-weight:700;">' + formatPrice(t.unit_price) + ' €</td>';
      html += '<td><span class="cvr-modal__tiers-badge ' + (disc > 0 ? 'has-discount' : '') + '">' + (disc > 0 ? '-' + disc + '%' : '—') + '</span></td>';
      html += '</tr>';
    });
    html += '</tbody></table>';
    box.innerHTML = html;
    box.style.display = '';
  }

  function hideTiers() {
    var box = document.getElementById('cvr-modal-tiers');
    if (box) { box.innerHTML = ''; box.style.display = 'none'; }
  }

  window.cvrModalSelectTier = function (idx) {
    var data = currentTiers();
    if (!data || !data[idx]) return;
    M.tierIdx = idx;
    M.qty = data[idx].qty;
    var qi = document.getElementById('cvr-modal-qty');
    if (qi) qi.value = M.qty;
    highlightTier();
    updatePrice();
  };

  function highlightTier() {
    var rows = document.querySelectorAll('#cvr-modal-tiers tbody tr');
    Array.prototype.forEach.call(rows, function (r, i) { r.classList.toggle('is-active', i === M.tierIdx); });
  }

  /* ── QUANTITÉ ── */
  window.cvrModalAdjustQty = function (d) {
    M.qty = Math.max(1, M.qty + d);
    var qi = document.getElementById('cvr-modal-qty');
    if (qi) qi.value = M.qty;
    syncTierFromQty();
  };
  window.cvrModalQtyInput = function (val) {
    M.qty = Math.max(1, parseInt(val, 10) || 1);
    syncTierFromQty();
  };

  function syncTierFromQty() {
    var data = currentTiers();
    if (data) {
      var idx = 0;
      for (var i = 0; i < data.length; i++) { if (data[i].qty <= M.qty) idx = i; }
      M.tierIdx = idx;
      highlightTier();
    }
    updatePrice();
  }

  /* ── PRIX ── */
  function updatePrice() {
    var elPrice = document.getElementById('cvr-modal-price');
    var elUnit  = document.getElementById('cvr-modal-price-unit');
    var data    = currentTiers();

    if (data) {
      // Prix basé sur le palier applicable (en lots)
      var idx = 0;
      for (var i = 0; i < data.length; i++) { if (data[i].qty <= M.qty) idx = i; }
      var unitLot   = data[idx].unit_price;         // prix d'UN lot
      var total     = unitLot * M.qty;              // total (nb de lots)
      var perPiece  = M.units > 0 ? unitLot / M.units : unitLot;
      var totalUnits = M.units * M.qty;
      var baseTotal = data[0].unit_price * M.qty;

      if (elPrice) {
        elPrice.textContent = formatPrice(total) + ' €';
        elPrice.classList.toggle('has-discount', idx > 0);
      }
      if (elUnit) {
        elUnit.textContent = formatPrice(perPiece, 4) + ' €/' + tr('unit_abbr', 'u') + ' · ' + formatNum(totalUnits) + ' ' + tr('units', 'unités');
      }
    } else {
      // Prix simple × quantité
      var cents = M.variant ? (M.variant.price || 0) : 0;
      var euros = (cents / 100) * M.qty;
      if (elPrice) {
        elPrice.textContent = formatPrice(euros) + ' €';
        elPrice.classList.remove('has-discount');
      }
      if (elUnit) {
        elUnit.textContent = M.qty > 1 ? (M.variant ? M.variant.price_money + ' ' + tr('per_lot', '/ lot') : '') : '';
      }
    }
  }

  function currentTiers() {
    return (M.tiers && M.sku && M.tiers[M.sku] && M.tiers[M.sku].length) ? M.tiers[M.sku] : null;
  }

  /* ── GALERIE ── */
  function renderGallery() {
    var img = document.getElementById('cvr-modal-main-img');
    var thumbs = document.getElementById('cvr-modal-thumbs');
    var prev = document.querySelector('.cvr-modal__nav--prev');
    var next = document.querySelector('.cvr-modal__nav--next');

    if (!M.images.length) { if (img) img.src = ''; if (thumbs) thumbs.innerHTML = ''; return; }
    if (img) { img.src = M.images[M.imgIdx]; img.alt = M.title; }

    var multi = M.images.length > 1;
    if (prev) prev.hidden = !multi;
    if (next) next.hidden = !multi;

    if (thumbs) {
      if (multi) {
        var html = '';
        M.images.forEach(function (src, i) {
          html += '<button type="button" class="cvr-modal__thumb ' + (i === M.imgIdx ? 'is-active' : '') + '" onclick="cvrModalGoto(' + i + ')"><img src="' + src + '" alt=""></button>';
        });
        thumbs.innerHTML = html;
      } else {
        thumbs.innerHTML = '';
      }
    }
  }

  window.cvrModalNav = function (d) {
    if (!M.images.length) return;
    M.imgIdx = (M.imgIdx + d + M.images.length) % M.images.length;
    refreshGallery();
  };
  window.cvrModalGoto = function (i) { M.imgIdx = i; refreshGallery(); };

  function refreshGallery() {
    var img = document.getElementById('cvr-modal-main-img');
    if (img) img.src = M.images[M.imgIdx];
    var thumbs = document.querySelectorAll('#cvr-modal-thumbs .cvr-modal__thumb');
    Array.prototype.forEach.call(thumbs, function (t, i) { t.classList.toggle('is-active', i === M.imgIdx); });
  }

  /* ── AJOUT PANIER ── */
  window.cvrModalAddToCart = function () {
    if (!M.variant || !M.variant.available) return;
    var add = document.getElementById('cvr-modal-add');
    var qty = M.qty;
    if (add) { add.disabled = true; add.textContent = tr('adding', 'Ajout en cours…'); }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: M.variant.id, quantity: qty })
    })
    .then(function (r) { if (!r.ok) throw new Error('Erreur ' + r.status); return r.json(); })
    .then(function () {
      if (add) { add.disabled = false; add.textContent = tr('added', '✓ Ajouté !'); add.classList.add('is-added'); }
      document.dispatchEvent(new CustomEvent('cart:updated'));
      if (window.theme && window.theme.cart && typeof window.theme.cart.open === 'function') window.theme.cart.open();
      setTimeout(function () {
        if (add) { add.textContent = tr('add_to_cart', 'Ajouter au panier'); add.classList.remove('is-added'); }
      }, 1600);
    })
    .catch(function () {
      if (add) { add.disabled = false; add.textContent = tr('error_retry', 'Erreur — réessayer'); }
    });
  };

  /* ── UTILITAIRES ── */
  function parseUnits(title) {
    if (!title) return 1;
    var m = title.match(/(\d[\d\s]*)/);
    return m ? parseInt(m[1].replace(/\s/g, ''), 10) : 1;
  }
  function setText(id, txt) { var el = document.getElementById(id); if (el) el.textContent = txt; }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function formatPrice(v, d) { return parseFloat(v).toFixed(d !== undefined ? d : 2).replace('.', ','); }
  function formatNum(v) { return parseInt(v, 10).toLocaleString(numLocale()); }

})();